import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { AccessType } from '@classes/access-type';
import { AccessTypeService } from 'app/core/services/access-type.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-access-type-list',
  templateUrl: './access-type-list.component.html',
  styleUrls: ['./access-type-list.component.scss']
})
export class AccessTypeListComponent implements OnInit {

  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this._initFilteredAccessTypes();
    }
  }
  @Input() placeHolder: string;

  myControl!: FormControl;

  accessTypes: AccessType[] = [];
  filteredAccessTypes: Observable<AccessType[]> | undefined;

  constructor(
    public accessTypeService: AccessTypeService
  ) {
    this._initList();
  }

  ngOnInit() {
  }

  private _initList() {
    this.accessTypeService.getAccessTypes().subscribe(accessTypeService => {
      this.accessTypes = accessTypeService
      .sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));;
      this._initFilteredAccessTypes();
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredAccessTypes(): void {
    if (this.myControl) {
      this.filteredAccessTypes = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return [];
          })
        );
    }
  }

  private _filter(value: string): AccessType[] {
    const filterValue = value.toLowerCase();
    return this.accessTypes.filter(option => (option.name || '').toLowerCase().includes(filterValue));
  }

  displayFn(accessType?: AccessType): string {
    return accessType ? (accessType.name || '') : '';
  }
}
